import React, { memo } from 'react';
import { View } from 'react-native';
import { createUseStyle } from '@redlink/assets/styles';
import { Icon, Text, Space } from '@redlink/components/atoms';

export const LogoItemHorizontal = memo(({ item }) => {
  const { styles, colors } = useStyle();
  return (
    <View style={styles.container}>
      <Icon name={item} color={colors.black} />
      <Space size={8} />
      <Text style={styles.titleText}>{item}</Text>
    </View>
  );
});

const useStyle = createUseStyle(({ colors, size, ltrFlexDirection }) => ({
  container: {
    flexDirection: ltrFlexDirection,
    alignItems: 'center',
    paddingHorizontal: 8,
  },
  titleText: {
    marginTop: 5,
    fontSize: 14,
    color: colors.black
  },
}));
